import React from 'react';
import { Link } from 'gatsby';
import Toggle from '~components/toggle';

const Nav = () => (
  <nav className="sticky top-0 z-30 flex justify-center items-center w-full px-4 py-4 my-0 mb-8 backdrop-filter backdrop-blur-lg bg-opacity-10 firefox:bg-opacity-90 border-b border-primary">
    <div className="flex justify-between items-center max-w-2xl w-full">
      <div className="text-primary font-semibold">
        <Link className="cursor-pointer" to="/">
          Christos Malamas
        </Link>
      </div>
      <div className="flex items-center space-x-4 justify-evenly text-primary">
        <Link className="cursor-pointer md:block hidden" to="/">
          Home
        </Link>
        <Link className="cursor-pointer" to="/case-study-metavaders">
          Case Study
        </Link>
        <Toggle />
      </div>
    </div>
  </nav>
);

export default Nav;
